import axios from "axios";
import {
  clearLocalStorage,
  getIdToken,
  getTokenType,
  setAuthTokens,
} from "../../utils/tokenHelper.ts";
import { refreshToken } from "../modules/auth";
import { GET_REFRESH_AUTH_TOKEN } from "../modules/auth/endpoints.ts";
import { useToast } from "vue-toastification";

const instance = axios.create({
  baseURL: "",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

instance.defaults.baseURL = import.meta.env.VITE_VUE_APP_BASE_URL;

// REQUEST INTERCEPTOR
instance.interceptors.request.use((config) => {
  const idToken = getIdToken();
  const tokenType = getTokenType();
  config.headers.Authorization = idToken ? `${tokenType} ${idToken}` : "";
  return config;
});

// RESPONSE INTERCEPTOR (clean + fixed)
instance.interceptors.response.use(
  (response) => {
    if (response.config?.responseType === "blob") {
      return response;
    }

    if (response.status === 200 || response.status === 201) {
      return response.data;
    }

    return response;
  },

  async (error) => {
    console.log(error);

    // 401 - token refresh except refresh request itself
    if (
      error.response?.status === 401 &&
      error.response.config?.url !== GET_REFRESH_AUTH_TOKEN
    ) {
      localStorage.removeItem("id_token");

      const tokens = await refreshToken();
      if (tokens) {
        setAuthTokens(tokens);
        const config = error.response.config;
        config.headers.Authorization = `Bearer ${tokens.access_token}`;
        return instance(config);
      }
    }

    // 401 - refresh also failed
    if (error.response?.status === 401) {
      clearLocalStorage();
      window.location = import.meta.env.VITE_VUE_APP_MICROSOFT_AUTH_LINK;
      return Promise.reject(error);
    }

    // Custom error parsing
    const apiData = error.response?.data;

    const toast = useToast();

    if (apiData?.status) {
      toast.error(apiData.status.message);
    } else {
      Object.keys(apiData || {})
        .filter((key) => key !== "status" && key !== "bad_data")
        .forEach((key) => {
          toast.error(apiData[key][0]);
        });
    }

    return Promise.reject(error);
  }
);

export default instance;
